import { Component, Input, OnInit } from '@angular/core';
import { AccionesSancionesEnum } from '../../containers/bandeja-principal/administrador/gestion/sanciones-personas/sanciones-persona.enum';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertsService } from '../../../../shared/services/alerts.service';
import { ModalSancionesPersonaService } from './modal-asignar-sancion-persona.service';
import { EstablecimientoComercioService } from '../../containers/bandeja-principal/prestador/establecimiento-comercio/establecimiento-comercio.service';
import { ConfirmarRespuestaModel, ConfirmarRespuestaType, TipoConfirmacionModalType } from 'src/app/shared/models/confirmar-respuesta.model';
import { ModalConfirmarRespuestaComponent } from 'src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';

@Component({
  selector: 'app-modal-modificar-sancion-persona',
  templateUrl: './modal-modificar-sancion-persona.component.html'
})
export class ModalModificarSancionPersonaComponent implements OnInit {
  form: FormGroup;
  file: File = null;
  @Input() type: AccionesSancionesEnum;
  @Input() sancion_id: number;
  id_eliminar = AccionesSancionesEnum.eliminar;
  id_innactivar = AccionesSancionesEnum.innactivar;

  constructor(private formBuilder: FormBuilder,
              private activeModal: NgbActiveModal,
              private alertService: AlertsService,
              private modalSancionesPersonaService: ModalSancionesPersonaService,
              private establecimientoComercioService: EstablecimientoComercioService,
              private modalService: NgbModal) {
    
  }

  ngOnInit(): void {
    this.initForm();
  }
  initForm(): void{
    if(this.type == AccionesSancionesEnum.innactivar){
      this.form = this.formBuilder.group({
        motivo      : ['',[Validators.required]],
        archivo     : ['',[Validators.required]],
      });
    }
    if(this.type == AccionesSancionesEnum.eliminar){
      this.form = this.formBuilder.group({
        motivo      : ['',[Validators.required]],
        archivo     : ['',],
      });
    }
  }
  dismiss(): void {
    if (this.activeModal) {
      this.activeModal.dismiss();
    }
  }
  sendForm(): void{
    if(this.form.valid){  
      if(this.type == AccionesSancionesEnum.innactivar){
        this.onInnactivar();
      }else{
        this.onEliminar();
      }
    }
  }
  onEliminar(): void{
    this.establecimientoComercioService
          .getParametro({
            parametro_id:'ADVERTENCIA_CONFIRMAR_ELIMINACION_SANCION_PERSONA',
            agrupacion:'VALIDACIONES',
            auxiliar:'1',
          }).subscribe((response) => {
              if (response.result) {
                let data: any = {
                  imagen: '',
                  type: ConfirmarRespuestaType.Atencion,
                  tipoConfirmacionModalType: TipoConfirmacionModalType.Confirmacion,
                  message: response.data
                };
                const modal = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
                modal.componentInstance.confirmarRespuesta = data;
                modal.result.then(()=>{
                  this.eliminar();
                });
              }
          }
      );
    
  }
  
  onInnactivar(): void{
    this.establecimientoComercioService
          .getParametro({
            parametro_id:'ADVERTENCIA_CONFIRMAR_INNACTIVACION_SANCION_PERSONA',
            agrupacion:'VALIDACIONES',
            auxiliar:'1',
          }).subscribe((response) => {
              if (response.result) {
                let data: any = {
                  imagen: '',
                  type: ConfirmarRespuestaType.Atencion,
                  tipoConfirmacionModalType: TipoConfirmacionModalType.Confirmacion,
                  message: response.data
                };
                const modal = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
                modal.componentInstance.confirmarRespuesta = data;
                modal.result.then(()=>{
                  this.innactivar();
                });
              }
          }
      );
    
  }
  innactivar(): void{
    this.modalSancionesPersonaService
        .innactivarSancion(
          {
              ...this.form.getRawValue(),
              sancion_id: this.sancion_id,
          }
          ,this.file).subscribe(response =>{
            if(response.data == null){
              this.dismiss();
            }
          })
  }
  eliminar(): void{
    this.modalSancionesPersonaService
        .eliminarSancion(
          {
              ...this.form.getRawValue(),
              sancion_id: this.sancion_id,
          }
          ,this.file)
          .subscribe(response =>{
            if( response.body || response.result){
              this.dismiss();
            }
          })
  }
  cancel() {
    this.form.controls["archivo"].setValue(null);
    this.file = null;
  }
  onFileInput(eventFile) {
    const tempo = eventFile.target.files as FileList;
    const file = tempo.item(0);

    if (tempo.item.length > 0) {
      if (file.size / 1024 / 1024 > 15) {
        this.alertService.warn(
          "Ha superado el tamaño máximo permitido (15Mb)",
          "",
          "sin-codigo"
        );
        this.cancel();
        return false;
      } else {
        this.file = tempo.item(0);
        this.form.value.archivo = tempo.item(0);
      }
    }
  }
}
